import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from "react-router-dom";

import App from './main/App'
import IntlProviderConfigured from './_i18n/IntlProviderConfigured';

// Automatic recovery for ChunkLoadError / Loading CSS chunk failed after new deployments
if (typeof window !== 'undefined') {
  const handleChunkError = (errorMsg) => {
    const text = String(errorMsg || '');
    if (
      text.includes('Loading chunk') ||
      text.includes('Loading CSS chunk') ||
      text.includes('failed to asynchronously load component')
    ) {
      const key = 'chunk_reload_timestamp';
      const last = sessionStorage.getItem(key);
      const now = Date.now();
      // Only reload if we haven't reloaded in the last 15 seconds to prevent reload loops
      if (!last || now - parseInt(last, 10) > 15000) {
        sessionStorage.setItem(key, now.toString());
        window.location.reload();
      }
    }
  };

  window.addEventListener('error', (event) => {
    handleChunkError(event.message || (event.error && event.error.message));
  });

  window.addEventListener('unhandledrejection', (event) => {
    handleChunkError(event.reason && (event.reason.message || event.reason.toString()));
  });
}

const domNode = document.getElementById('root');
const reactNode = (
    <IntlProviderConfigured>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IntlProviderConfigured>
);

if (domNode) {
  const root = createRoot(domNode);
  root.render(reactNode);
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
